export const CHAT_GROUPS = [
  "General",
  "Pubg",
  "Free fire",
  "Valorant",
  "Dota 2",
  "Stumble Guys",
];

export const GROUP_IMAGES = [
  {
    name: "General",
    image: "https://i.ibb.co/HgPCwrz/general.jpg",
  },
  {
    name: "Pubg",
    image: "https://i.ibb.co/BTRK4v3/pubg.jpg",
  },
  {
    name: "Free fire",
    image: "https://i.ibb.co/N6gP9rr/free-fire.jpg",
  },
  {
    name: "Valorant",
    image: "https://i.ibb.co/fCyLHd9/Valorant.jpg",
  },
  {
    name: "Dota 2",
    image: "https://i.ibb.co/BnwCFHr/dota-2.jpg",
  },
  {
    name: "Stumble Guys",
    image: "https://i.ibb.co/vdykKFb/stumble.jpg",
  },
];

export const ChatRoomActions = {
  JoinChatRoom: "chatroom_join",
  LeaveChatRoom: "chatroom_leave",
  SendMessage: "chatroom_message",
  ReceiveMessage: "receive_chatroom_message",
};
